import { useGetUserHashClientQuery, useGetUserHashEmulatorQuery } from '@bessemercws/graphql';

export const useGetUserHash = (isAdvisor: boolean, userId: string | null, isAuthing: boolean): string | null => {
  const clientResponse = useGetUserHashClientQuery({
    skip: isAdvisor || isAuthing,
  });
  const emulatorResponse = useGetUserHashEmulatorQuery({
    skip: !isAdvisor || !userId || isAuthing,
    variables: { userId: userId || '' },
  });

  if (isAdvisor) {
    return emulatorResponse.data?.advisor?.client?.user_id_hash || null;
  } else {
    return clientResponse.data?.viewer?.user_id_hash || null;
  }
};
